// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ContactInfoPurposeType } from './contactInfoPurposeType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TrialcardSiteV3ModelsSharedWebAddressUpsearchModel {
    'webAddressType'?: ContactInfoPurposeType;
    'url'?: string | null;
    'webAddressId'?: number | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TrialcardSiteV3ModelsSharedWebAddressUpsearchModel>> = [
        {
            "name":     "webAddressType",
            "baseName": "webAddressType",
            "type":     "ContactInfoPurposeType"
        },
        {
            "name":     "url",
            "baseName": "url",
            "type":     "string"
        },
        {
            "name":     "webAddressId",
            "baseName": "webAddressId",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return TrialcardSiteV3ModelsSharedWebAddressUpsearchModel.attributeTypeMap;
    }
}
